import React from 'react';
import styled from '@emotion/styled';
import { ListItemButton, ListItemIcon } from '@mui/material';
import { AppBarProps as MuiAppBarProperties }
  from '@mui/material/AppBar';
import PropTypes, { InferProps } from 'prop-types';

interface AppBarProperties extends MuiAppBarProperties {
  open?: boolean;
  isSubItem?: boolean;
}

const StyledListItem = styled.div<{ isSelected?: boolean }>`
  display: block;

  ${(properties) => properties.isSelected && `
    background-color: rgba(255, 122, 0, 0.2);

    span {
      color: rgb(255, 122, 0);
    }
  `}
`;

const StyledListItemButton = styled(({
  isSubItem,
  open,
  ...otherProperties
}: AppBarProperties) => (
  <ListItemButton component="div" {...otherProperties} />
))<AppBarProperties>`
  min-width: 0;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  .MuiCollapse-root {
    margin-top: -.5rem;
  }

  ${(properties) => properties.isSubItem && properties.open && `
    padding-left: 2rem;
  `}
`;

const StyledSubMenu = styled.span`
  position: absolute;
  right: 0;
  color: rgba(0, 0, 0, 0.54);
  padding-right: 12px;
  .MuiCollapse-root {
    margin-top: -.5rem;
  }
`;

const DrawerItemText = styled.span<AppBarProperties>`
  display: inline-block;
  padding: 0 0 0 .5rem;
  color: black;
  font-size: 14px;
  font-weight: bold;
  text-transform: none;
`;

const StyledListItemIcon = styled(ListItemIcon)<AppBarProperties>`
  min-width: 0;
  margin-left: -6px;
  justify-content: left;

  svg:nth-of-type(2) {
    margin-left: -6px;
  }

  svg {
    path {
      fill: #000;
    }
  }
`;

const drawerItemPropertyTypes = {
  Icon: PropTypes.elementType.isRequired,
  Submenu: PropTypes.elementType,
  name: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool,
  isSubItem: PropTypes.bool,
};

type DrawerItemProperties = InferProps<typeof drawerItemPropertyTypes> & {
  isSubItem?: boolean;
  isSelected?: boolean;
};

const DrawerItem = ({
  Icon, name, open, Submenu, isSelected, isSubItem,
} : DrawerItemProperties) => (
  <StyledListItem key={name} isSelected={isSelected}>
    <StyledListItemButton
      open={open}
      role="menuitem"
      isSubItem={isSubItem}
    >
      <StyledListItemIcon open={open}>
        <Icon
          titleAccess={name}
          role="img"
        />
        { Submenu && !open
        && (
          <Submenu
            titleAccess={name}
            role="img"
          />
        )}
      </StyledListItemIcon>
      <DrawerItemText>{ name }</DrawerItemText>
      { Submenu && (
      <StyledSubMenu>
        <Submenu
          titleAccess={name}
          role="img"
        />
      </StyledSubMenu>
      )}
    </StyledListItemButton>
  </StyledListItem>
);

DrawerItem.propTypes = drawerItemPropertyTypes;

export default DrawerItem;
